import * as React from 'react';
import * as moment from 'moment';

import { connect } from 'react-redux';

import ListPerformancesView from '../../views/library/list-performances.view';
import { IPackageListingAppState } from '../../redux-state/index';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformance } from '../../custom/classes/production';
import { IPackageListingAppSettings } from '../../custom/classes/package-listing-settings';

interface IListPerformancesExternalProps {
    filteredPerformances: Array<IPerformance>;
}

interface StateToProps {
    text: IPackageListingAppText;
    settings: IPackageListingAppSettings;
    allowReserve: boolean;
    showReserveButton: boolean;
}

interface ListPerformancesViewState {
    showAllPerformances: boolean;
}

interface ViewProps {
    toggleShowAllPerformances: () => void;
}


export type ListPerformancesProps = IListPerformancesExternalProps & StateToProps;

export type CombinedPerformancesViewProps = ListPerformancesProps & ListPerformancesViewState & ViewProps;


export class ListPerformancesBase extends React.Component<ListPerformancesProps, ListPerformancesViewState> {

    constructor(props: ListPerformancesProps) {
        super(props);

        this.state = {
            showAllPerformances: false
        };
    }
    render() {
        return (
            <ListPerformancesView showAllPerformances={this.state.showAllPerformances} toggleShowAllPerformances={this._toggleShowAllPerformances.bind(this)} {...this.props} />
        )
    }

    _toggleShowAllPerformances = () => {
        this.setState(
            { showAllPerformances: !(this.state.showAllPerformances) }
        );
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListPerformancesExternalProps): StateToProps {

    var props = {
        text: state.packageListingText,
        settings: state.packageListingSettings
    };

    if (state.packageListingSettings.isFixed) {

        return {
            ...props,
            showReserveButton: false,
            allowReserve: false
        };

    } else {
        const performanceIds = ownProps.filteredPerformances.map(p => p.performanceId);
        const cartPerformanceIds = Array.from(state.packageListing.cartItems.keys())
        const cartHasPerformance = performanceIds.filter(id => cartPerformanceIds.indexOf(id) >= 0).length > 0;

        return {
            ...props,
            showReserveButton: true,
            allowReserve: !(!state.packageListing.packageDetail.allowSameProductionReservation && cartHasPerformance)
                && state.packageListing.cartItems.size < state.packageListing.packageDetail.maximumPerformances
        }
    }

}

export default connect<StateToProps>(mapStateToProps)(ListPerformancesBase);